$(document).ready(function () {
    if ($('#like-btn').length > 0 || $('#dislike-btn').length > 0) {
        var lastSegment = getLastSegment();
        var actionTaken = localStorage.getItem(lastSegment);

        if (actionTaken) {
            $('#like-btn, #dislike-btn').prop('disabled', true).addClass('opacity-50 cursor-not-allowed');
            toggleButtonColor.call($('#' + actionTaken + '-btn'));

            if (actionTaken === 'like') {
                increaseLikeStyled();
            } else if (actionTaken === 'dislike') {
                increaseDislikeStyled();
                $('#like-btn').prop('disabled', false).removeClass('opacity-50 cursor-not-allowed');
            }
        }
        if ($('#like-btn, #dislike-btn')) {
            updateCounters();
        }

        //click events
        $('#like-btn').click(function () {
            handleFeedbackAction('like');
        });

        $('#dislike-btn').click(function () {
            toggleDislikeModal();
        });

        $('#close-modal').click(function () {
            $('#feedback-modal').addClass('hidden');
        });

        //send feedback on click of submit - save it in blog_feedback
        $('#submit-modal').click(function () {
            const feedbackText = $('#feedback-text').val();
            $.ajax({
                url: '/submit-blog-feedback',
                type: 'POST',
                data: {
                    feedback: feedbackText,
                    urlSegment: lastSegment
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (response) {
                    handleFeedbackAction('dislike');
                    $('#feedback-modal').addClass('hidden');
                    $('#dislike-btn').prop('disabled', true).addClass('opacity-50 cursor-not-allowed');
                    $('#feedback-text').val('');
                },
                error: function (xhr, status, error) {
                    if (xhr.status === 422) {
                        $('#min-feedback-text').removeClass('hidden');
                    }
                }
            });
        });
    }
});

function handleFeedbackAction(actionType) {
    var lastSegment = getLastSegment();
    var actionTaken = localStorage.getItem(lastSegment);

    //return if return user / page refreshed
    if (actionTaken === actionType) {
        return;
    }

    // If you click like after having previously clicked dislike then increase like & decrease dislike
    if (actionType === 'like' && actionTaken === 'dislike') {
        updateFeedbackCount({
            action: 'switch_from_dislike_to_like',
            urlSegment: lastSegment
        });

        toggleButtonColor.call($('#dislike-btn'));
        increaseLikeStyled();

        localStorage.setItem(lastSegment, actionType);

        toggleButtonColor.call($('#like-btn'));
        $('#dislike-btn').addClass('opacity-50 cursor-not-allowed'); // Keep it disabled but indicate the action change
    } 
    // if clicked on like-btn logic
    else if (actionType === 'like') {
        localStorage.setItem(lastSegment, actionType);
        toggleButtonColor.call($('#like-btn'));
        toggleFeedbackText();
        increaseLikeStyled();
        $('#dislike-btn').prop('disabled', true).addClass('opacity-50 cursor-not-allowed');
        updateFeedbackCount({
            action: actionType,
            urlSegment: lastSegment
        });
    } 
    // if clicked on dislike-btn logic
    else if (actionType === 'dislike') {
        localStorage.setItem(lastSegment, actionType);
        toggleButtonColor.call($('#dislike-btn'));
        toggleFeedbackText();
        increaseDislikeStyled();
        updateFeedbackCount({
            action: actionType,
            urlSegment: lastSegment
        });
    }
}

function getLastSegment() {
    var pathSegments = window.location.pathname.split('/').filter(function (segment) { return segment !== ""; });
    return pathSegments.pop();
}

function toggleButtonColor() {
    $(this).toggleClass('bg-white bg-green2025-100').toggleClass('text-black text-white');
    var fillColor = $(this).hasClass('bg-green2025-100') ? 'white' : 'none';
    $(this).find('svg').attr('fill', fillColor);
}

function toggleDislikeModal() {
    $('#feedback-modal').toggleClass('hidden');
}

function increaseLikeStyled() {
    $('#check-heart-gray path').attr('stroke', '#88498F');
    $('#like-counter').removeClass('text-[#AFAFAF]').addClass('text-green2025-100');
}

function increaseDislikeStyled() {
    $('#thumbs-down-gray path').attr('stroke', '#88498F');
    $('#dislike-counter').removeClass('text-[#AFAFAF]').addClass('text-green2025-100');
}

function toggleFeedbackText() {
    $('#leave-feedback-text').hide();
    $('#ty-feedback-text').removeClass('hidden');
}

function updateCounters() {
    var lastSegment = getLastSegment();

    $.get("/blog-feedback/" + lastSegment, function (data) {
        $("#like-counter").text(data.likes);
        $("#dislike-counter").text(data.dislikes);
    }).fail(function () {
    });
}

function updateFeedbackCount(actionData) {
    $.ajax({
        url: '/update-blog-feedback',
        type: 'POST',
        data: actionData,
        success: function (data) {
            $("#like-counter").text(data.likes);
            $("#dislike-counter").text(data.dislikes);
        },
        error: function () {
        }
    });
}
